var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":_vm.size,"type":"text"},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.getName()))])
}
var staticRenderFns = []

export { render, staticRenderFns }